import { gql } from "@apollo/client";

export const DeleteInstalledBaseNodeSubscription = gql`
    mutation DeleteInstalledBaseNodeSubscription ($id: ID!) {
        deleteInstalledBaseNodeSubscription(id: $id) {
            success
            message
        }
    }
`;
